import classNames from 'classnames';
import { FC, memo, ReactElement, useMemo } from 'react';

import {
  AvatarTypes,
  TAvatarBackgroundColorIndex,
  BaseAvatar,
  BaseAvatarTextContent,
  TAvatarBadge,
} from '@gem/ui-kit';

import { AsyncImage } from 'APP/components/AsyncImage/AsyncImage';

import styles from './Avatar.styles.m.css';
import { getAvatarUrlByType } from './Avatar.utils';

export { AvatarTypes };
export type { TAvatarBackgroundColorIndex };

interface IAvatarProps {
  className?: string;
  avatarClassName?: string;
  url?: string | null;
  type: AvatarTypes;
  isOnline?: boolean;
  hasLockIcon?: boolean;
  children?: ReactElement;
  title?: string | null;
  backgroundColorIndex?: TAvatarBackgroundColorIndex | null;
  badge?: TAvatarBadge;
}

export const Avatar: FC<IAvatarProps> = memo((props) => {
  const {
    type,
    url,
    className,
    avatarClassName,
    title,
    backgroundColorIndex,
    children,
    isOnline,
    hasLockIcon,
    badge,
  } = props;

  const avatarImageClassName = classNames(styles.avatarImage, avatarClassName);

  const resizedUrl = useMemo(() => url && getAvatarUrlByType(type, url), [url, type]);

  const textContent = children || (
    <BaseAvatarTextContent
      className={avatarClassName}
      type={type}
      backgroundColorIndex={backgroundColorIndex}
      title={title}
    />
  );

  return (
    <BaseAvatar
      type={type}
      className={className}
      url={url}
      hasLockIcon={hasLockIcon}
      isOnline={isOnline}
      badge={badge}
    >
      {resizedUrl ? (
        <AsyncImage
          className={avatarImageClassName}
          src={resizedUrl}
          alt=""
        >
          {textContent}
        </AsyncImage>
      ) : (
        textContent
      )}
    </BaseAvatar>
  );
});
